import React from 'react'
import { withStyles } from '@material-ui/core'
import PropTypes from 'prop-types'

import NameBlock from '../NameBlock/NameBlock'
import AttributeBlock from '../AttributeBlock/AttributeBlock'
import VersionBlock from '../VersionBlock/VersionBlock'
import DeleteBotBlock from '../DeleteBotBlock/DeleteBotBlock'
import ContextualConversationsBlock from '../ContextualConversationsBlock'
import BotEnablerBlock from '../BotEnablerBlock'
import LivechatEnablerBlock from '../LivechatEnablerBlock'

import { styles } from './styles'

const General = ({ classes }) => {
  return (
    <div className={classes.container}>
      <NameBlock />
      <AttributeBlock />
      <VersionBlock />
      <ContextualConversationsBlock />
      <BotEnablerBlock />
      <LivechatEnablerBlock />
      <DeleteBotBlock />
    </div>
  )
}

General.propTypes = {
  classes: PropTypes.object,
}

export default withStyles(styles)(General)
